export const ROUNDS_CONFIG = {
  PERCENT_INCREMENT_PER_ROUND: 0.05,
} as const;

export interface RoundState {
  readonly roundNumber: number;
  readonly roundStartMoney: number;
  readonly requirementPercent: number;
  readonly requiredAmount: number;
}

function getRequirementPercent(roundNumber: number): number {
  return Math.max(0, roundNumber) * ROUNDS_CONFIG.PERCENT_INCREMENT_PER_ROUND;
}

export class RoundsManager {
  private state: RoundState | null = null;

  public startFirstRound(startingMoney: number): RoundState {
    const roundNumber = 1;
    const requirementPercent = getRequirementPercent(roundNumber);
    const requiredAmount = startingMoney * requirementPercent;
    this.state = {
      roundNumber,
      roundStartMoney: startingMoney,
      requirementPercent,
      requiredAmount,
    };
    return this.state;
  }

  public startNextRound(currentMoney: number): RoundState {
    const nextRound = (this.state?.roundNumber ?? 0) + 1;
    const requirementPercent = getRequirementPercent(nextRound);
    const requiredAmount = currentMoney * requirementPercent;
    this.state = {
      roundNumber: nextRound,
      roundStartMoney: currentMoney,
      requirementPercent,
      requiredAmount,
    };
    return this.state;
  }

  public getState(): Readonly<RoundState> | null {
    return this.state;
  }

  public getRemainingAmount(currentPortfolioValue: number): number {
    if (!this.state) return 0;
    const profit = currentPortfolioValue - this.state.roundStartMoney;
    const remaining = this.state.requiredAmount - profit;
    return Math.max(0, Math.round(remaining));
  }

  public getRequiredAmount(): number {
    if (!this.state) return 0;
    return Math.round(this.state.requiredAmount);
  }

  public isRoundPassed(finalMoney: number): boolean {
    if (!this.state) return false;
    const profit = finalMoney - this.state.roundStartMoney;
    return profit >= this.state.requiredAmount;
  }
}
